import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const calculateMaxVisibleTabs = () => {
    const width = window.innerWidth;
    if (width > 500) return 5;
    if (width > 408) return 4;
    if (width > 385) return 3;
    if (width > 364) return 2;
    return 1;
};

const TabMenuSkeleton = () => {
    const [visibleTabs, setVisibleTabs] = useState(calculateMaxVisibleTabs());

    useEffect(() => {
        const handleResize = () => {
            setVisibleTabs(calculateMaxVisibleTabs());
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="flex items-center justify-center gap-1 py-2">
            {Array.from({ length: visibleTabs }).map((_, i) => (
                <Skeleton key={i} width={80} height={32} />
            ))}
            <Skeleton width={32} height={32}/>
        </div>
    );
};

export default TabMenuSkeleton;